export default {
    appname: 'Directório Pesquisador',
    general: {
        logout: 'Sair',
        yes: 'Sim',
        no: 'Não',
        save: 'Guardar',
        update: 'Actualizar',
    },
    firstlogin: {
        title: 'Benvindo ao novo Portal de Sócio',
        subtitle: 'Este é a sua primeira entrada, e precisamos de confirmar alguns dados.',
        step1_title: 'Confirmação de Email',
        step1_subtitle: 'O seu email é este? {email}',
        step1_myemail: 'Confirmo que é o meu Email.',
        step1_notmyemail: 'Não é o meu Email.',
        step2_title: 'Código de Confirmação',
        step2_subtitle: 'Foi enviado para o seu Email um código de confirmação. ' +
                        'Por favor insira esse código para finalizar a confirmação do seu email.',
        generic_contactar_das_title: 'Por favor Contactar SNQTB',
        generic_contactar_das_subtitle: 'Como é o seu primeiro Login, ' +
                                        'esta informação tem de ser alterada directamente com o SNQTB.',
        step2_code: 'Código Recebido',
        step2_didnotreceive: 'Não recebi Código.',
        step2_confirm: 'Confirmar Código',
        step3_title: 'Alteração de Password',
        step3_subtitle: 'É agora necessário alterar a sua password para uma mais recente.',
        step3_confirm: 'Alterar Password',
        step3_error_newpass: 'A sua Password tem de ser igual nos dois campos, e ter mais de 8 caracteres',
        step3_pass: 'Nova Password:',
        step3_passagain: 'Nova Password novamente:',
        step4_title: 'Confirmação de Telemovel',
        step4_subtitle: 'O seu telemovel é este? {telemovel}',
        step4_myemail: 'Confirmo que é o meu Telemovel.',
        step4_notmyemail: 'Não é o meu Telemovel.',
        step5_title: 'Numero de Telemovel',
        step5_subtitle: 'Qual o seu numero de telemovel?',
        step5_mobile: 'Numero do Telemovel:',
        step5_back: 'Voltar ao Passo Anterior',
        step5_confirm: 'Confirmar este novo número',
        step6_title: 'Código de Confirmação SMS',
        step6_subtitle: 'Foi enviado para o seu Telemovel um código de confirmação. ' +
        'Por favor insira esse código para finalizar a confirmação do seu Telemovel.',
        step6_code: 'Código Recebido',
        step6_didnotreceive: 'Não recebi Código.',
        step6_confirm: 'Confirmar Código',
    },
    dashboard: {
        title: 'Dashboard',
    },
    myaccount: {
        title: 'A Minha Conta',
        myrequests: {
            title: 'Os Meus Pedidos',
            termos: {
                title: 'Lista Termos',
            },
            pedido_auth_item: {
                title: 'Pedido de Autorização',
            },
            pedido_auth_list: {
                title: 'Todos Pedido de Autorização',
            },
            reembolsos: {
                title: 'Pedidos de Reembolsos',
            },
            reembolsos_item: {
                title: 'Reembolso Item',
            },
            esclarecimentos: {
                title: 'Pedidos de Esclarecimentos',
            },
            esclarecimentos_item: {
                title: 'Esclarecimento Item',
            },
        },
        mydata: {
            title: 'Os meus dados',
        },
        groupdata: {
            title: 'Dados do Agregado',
        },
        groupmemberitem: {
            title: 'Dados do Membro do Agregado',
        },
        subsidios: {
            title: 'Subsidios',
        },
        consentimento: {
            title: 'Consentimento Especifico',
            bsp: 'Generalli - BSP',
            bspitem: {
                title: 'Consentimento Generalli BSP',
                description: 'Hardcoded Description on Lang File,  Hardcoded Description on Lang File,  ' +
                            'Hardcoded Description on Lang File,  Hardcoded Description on Lang File,  ' +
                            'Hardcoded Description on Lang File,  Hardcoded Description on Lang File,  ' +
                            'Hardcoded Description on Lang File,  Hardcoded Description on Lang File,  ' +
                            'Hardcoded Description on Lang File,  Hardcoded Description on Lang File,  ' +
                            'Hardcoded Description on Lang File,  Hardcoded Description on Lang File,  ' +
                            'Hardcoded Description on Lang File,  Hardcoded Description on Lang File,  ' +
                            'Hardcoded Description on Lang File,  Hardcoded Description on Lang File,  ' +
                            'Hardcoded Description on Lang File,  Hardcoded Description on Lang File,  ',
                faq_title: 'Faq',
                consentimentos_title: 'Consentimentos',
                savechanges: 'Guardar Alterações',
            },
        },
    },
    sams: {
        title: 'O Meu SNQTB Saúde',
        minhascondicoes: {
            title: 'As minhas condições',
        },
        utilizacaoconsumos: {
            title: 'Utilização e Consumos',
        },
        plafoms: {
            title: 'Plafoms',
        },
        cartoes: {
            title: 'Cartões',
        },
        redeinformada: {
            title: 'Rede Informada',
        },
        documentos: {
            title: 'Documentos',
        },
        orcamentos: {
            title: 'Orçamentos',
        },
        orcamentoitem: {
            title: 'Orçamento',
        },
    },
    preciso: {
        title: 'Preciso de',
        maisinfo: 'Mais Informações',
        faq: {
            title: 'FAQ',
        },
        pedidoesclarecimento: {
            title: 'Efectuar Pedido de Esclarecimento',
        },
        entregardespesa: {
            title: 'Entrega Despesa',
        },
        pedirautorizacao: {
            title: 'Pedir Autorizaçao',
        },
        apoiojuridico: {
            title: 'Apoio Jurídico',
        },
    },
    agendasindicato: {
        title: 'Agenda do Sindicato',
    },
    comunicacoes: {
        title: 'Comunicações',
    },
    formularios: {
        title: 'Formulários',
    },
    dirpesquisador: {
        title: 'Directório Pesquisador',
    },
    pesquisa: {
        title: 'Pesquisa',
    },
    notificacoes: {
        title: 'Notificações',
    },
    impersonate: {
        title: 'Assumir Identidade',
    },
};
